// extracted by mini-css-extract-plugin
export default {"home__top":"Home_home__top__vpfut","brand__ad":"Home_brand__ad__asKVs"};